import React from "react";
import AgentSearchVehicle from "../components/AgentSearchVehicle";
export default function AgentVehicleSearch() {
  return (
    <>
      <AgentSearchVehicle />
    </>
  );
}
